import React from "react";
import { Four  } from "./Chart.config";
import ShreeDayTable from "./ShreeDayTable";

const ShreeDay = ({ chartData }) => {
   return <ShreeDayTable staticData={Four} chartData={chartData} />;
 
};

export default ShreeDay;
